import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <p className="Footer">
      Open-source coded by{" "}
      <a href="https://github.com/isabellamacht">Isabella Macht</a>{" "}
    </p>
  );
}
